import { styled } from "@mui/material";

export const FormGeneratorStyled = styled("form")<{ hasColumn: boolean, gridColumnNumber: number }>(
    ({ hasColumn, gridColumnNumber }) => `
    max-width: ${hasColumn ? "100%" : gridColumnNumber ? "900px" : "500px"};
    width: 100%;
    margin: 0 auto;
`
);
